import React from 'react'
import { FieldProps, getIn } from 'formik'
import clsx from 'clsx'

const FormikCheckbox: React.ComponentType<FieldProps & { label: string; orientation?: 'LEFT' | 'RIGHT' }> = ({
  field: { value, ...field },
  form,
  label,
  orientation = 'RIGHT',
  ...rest
}) => {
  const error = getIn(form.errors, field.name)
  const isTouched = getIn(form.touched, field.name)
  const hasError = isTouched && error
  console.debug('field', field)
  const checkbox = (
    <div className={clsx('flex h-5 items-center', orientation === 'LEFT' ? 'mr-3' : 'ml-3')}>
      <input
        id={field.name}
        style={{ boxShadow: 'none' }}
        className="text-secondary-700 form-checkbox h-4 w-4 cursor-pointer rounded border-gray-300 focus:ring-0"
        type="checkbox"
        checked={value}
        {...field}
        {...rest}
      />
    </div>
  )

  return (
    <div className="relative flex items-start">
      {orientation === 'LEFT' && checkbox}
      <label htmlFor={field.name} className="cursor-pointer select-none text-sm text-gray-700">
        {label}
      </label>
      {orientation === 'RIGHT' && checkbox}
      {hasError ? (
        <p className="mt-1 text-xs text-red-900" id={`${field.name}-error`}>
          {error}
        </p>
      ) : null}
    </div>
  )
}

export default FormikCheckbox
